import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const CreateContentDataPreloader: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateContentDataPreloader" */ '../src/CreateContentDataPreloader.tsx'
			)
		).CreateContentDataPreloader,
});
